export default
{
  HotLines: [],
  HotLine: {},
}
